// components/organization/CreateUserModal.jsx
import React, { useState } from "react";
import PermissionSelector from "./PermissionSelector";
import { httpRequest } from "../../utils/httpRequest";
import { toast } from "react-toastify";
import CategoryScopeSelector from "./CategoryScopeSelector";

const CreateUserModal = ({ isOpen, onClose, onCreated }) => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    tags: "",
    permissions: [],
    categoryScopes: [], // 👈 جدید: string[]
  });
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        name: form.name,
        phone: form.phone,
        email: form.email ? form.email : undefined,
        tags: form.tags
          .split(",")
          .map((t) => t.trim())
          .filter(Boolean),
        permissions: form.permissions,
        categoryScopes: form.categoryScopes, // 👈 اضافه شد
      };

      const token = JSON.parse(localStorage.getItem("user"))?.token;
      await httpRequest("POST", "/user", payload, {
        "x-access-token": token,
      });

      toast.success("کاربر با موفقیت ایجاد شد");
      onCreated();
      onClose();
    } catch (err) {
      toast.error(err?.response?.data?.message || "خطا در ایجاد کاربر");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-50"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-2xl shadow-lg w-full max-w-2xl p-6 space-y-4 max-h-[80vh] overflow-y-scroll"
      >
        <h2 className="text-lg font-bold text-gray-800 mb-4">
          ایجاد کاربر جدید
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm mb-1">نام و نام خانوادگی</label>
            <input
              name="name"
              value={form.name}
              onChange={handleChange}
              className="border rounded-md w-full px-3 py-2"
            />
          </div>

          <div>
            <label className="block text-sm mb-1">شماره موبایل</label>
            <input
              name="phone"
              value={form.phone}
              onChange={handleChange}
              className="border rounded-md w-full px-3 py-2"
              placeholder="09123456789"
            />
          </div>

          <div>
            <label className="block text-sm mb-1">ایمیل (اختیاری)</label>
            <input
              name="email"
              value={form.email}
              onChange={handleChange}
              className="border rounded-md w-full px-3 py-2"
            />
          </div>

          <div>
            <label className="block text-sm mb-1">تگ‌ها (با کاما جدا کن)</label>
            <input
              name="tags"
              value={form.tags}
              onChange={handleChange}
              className="border rounded-md w-full px-3 py-2"
              placeholder="teacher, editor"
            />
          </div>

          <PermissionSelector
            selected={form.permissions}
            onChange={(perms) => setForm({ ...form, permissions: perms })}
          />

          <CategoryScopeSelector
            selected={form.categoryScopes}
            onChange={(ids) => setForm((f) => ({ ...f, categoryScopes: ids }))}
          />

          <div className="flex justify-end gap-2 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-600 bg-gray-200 rounded-lg"
            >
              انصراف
            </button>
            <button
              type="submit"
              disabled={loading}
              className={`px-4 py-2 rounded-lg text-white bg-purple-600 hover:bg-purple-700 transition ${
                loading ? "opacity-60 cursor-not-allowed" : ""
              }`}
            >
              {loading ? "در حال ایجاد..." : "ایجاد کاربر"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateUserModal;
